import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Paper,
  Radio,
  RadioGroup,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  Zoom,
} from '@mui/material';
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from '../../../redux/usersRedux';
import { analyzeLabResult } from '../../../utils/analyzeLabResult';
import {
  createRnfiz1Request,
  removeRnfiz1Request,
} from '../../../redux/rnfizRedux';
import { loadReportPZ05ByIdRequest } from '../../../redux/reportsPZ05Redux';
import { loadReportPZ04ByIdRequest } from '../../../redux/reportsPZ04Redux';
const RN_Fiz_1 = ({ props }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const user = useSelector((state) => getUser(state));
  const [reportNumber, setReportNumber] = useState(
    props ? props.reportNumber : '',
  );
  const [analyzeDate, setAnalyzeDate] = useState(
    props.RN_Fiz_1.length > 0
      ? dayjs(props.RN_Fiz_1[0].analyzeDate)
      : dayjs(new Date()),
  );
  const [expirityDate, setExpirityDate] = useState(
    props ? dayjs(props.expirityDate) : null,
  );
  const [arrRn_1, setArrRn_1] = useState(props ? props.RN_Fiz_1 || [] : []);
  const [parameterId, setParameterId] = useState('');
  const [parameterDes, setParameterDes] = useState('');
  const [parameter, setParameter] = useState(null);
  const [bbtResults, setBbtResults] = useState('');
  const [analyzeResults, setAnalyzeResults] = useState('');
  const [comment, setComment] = useState('');
  const [beerLock, setBeerLock] = useState(props ? props.beerLock : '');
  const [radioValue, setRadioValue] = useState(props ? props.beerLock : '');
  const [packagingCode, setPackagingCode] = useState(
    props
      ? `${dayjs(props.expirityDate).format('DD.MM.YYYY')} ${
          props.orderBatch
        } ${props.BBT}`
      : null,
  );
  const [packagingType, setPackagingType] = useState(
    props ? props.orderProduct.package.description : '',
  );
  const [bbtRelease, setBbtRelease] = useState('');
  const [releaseRange, setReleaseRange] = useState('');
  const [releaseZone, setReleaseZone] = useState('');
  const [reload, setReload] = useState(0);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('');

  const handleRemove = async (array, id) => {
    const updatedArray = array.filter((item) => item.id !== id);
    setArrRn_1(updatedArray);

    const res = await dispatch(removeRnfiz1Request(id));
    if (res.status === 200) {
      setAlertMessage(t('rnModule.fiz_1.snackbar.successRemoveParameter'));
      setAlertSeverity('success');
      setAlertOpen(true);
    } else {
      setAlertMessage(t('rnModule.fiz_1.snackbar.errorRemoveParameter'));
      setAlertSeverity('error');
      setAlertOpen(true);
    }
  };
  const handleBeerLock = (e) => {
    setBeerLock(e.target.value === 'true' ? true : false);
    setRadioValue(e.target.value);
  };

  useEffect(() => {
    const start = async () => {
      const report = await dispatch(loadReportPZ04ByIdRequest(props.id));
      if (report) {
        setArrRn_1(report.data.RN_Fiz_1);
      }
    };
    start();
  }, [dispatch, props.id, reload]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const analyzeData = analyzeLabResult(parameter, analyzeResults, bbtResults);
    const data = {
      reportPZ04Id: props.id,
      analyzeDate: analyzeDate,
      parameterName: parameterDes,
      specification: parameter
        ? `${parameter.specLabel} ${parameter.parameter.unit}`
        : '',
      bbtRelease: analyzeData.bbtRelease,
      comment: comment,
      packagingCode: packagingCode,
      analyzeResults: analyzeData.analyzeResults,
      releaseRange: analyzeData.releaseRange,
      releaseZone: analyzeData.releaseZone,
      bbtResults: analyzeData.bbtResults,
      userId: user.users.id,
    };

    setAnalyzeResults(analyzeData.analyzeResults);
    setBbtResults(analyzeData.bbtResults);
    setBbtRelease(analyzeData.bbtRelease);
    setReleaseRange(analyzeData.releaseRange);
    setReleaseZone(analyzeData.releaseZone);

    // Handle form submission logic here
    const res = await dispatch(createRnfiz1Request(data));
    setReload(reload + 1);
    if (res.status === 201) {
      setAlertMessage(t('rnModule.fiz_1.snackbar.successAddParameter'));
      setAlertSeverity('success');
      setAlertOpen(true);
    } else {
      setAlertMessage(t('rnModule.fiz_1.snackbar.errorAddParameter'));
      setAlertSeverity('error');
      setAlertOpen(true);
    }
  };

  const allowed = ['LABO', 'SUPER_LABO', 'ADMIN'].includes(user.users.role);

  return (
    <Box sx={{ overflow: 'auto', maxHeight: 'calc(100vh - 200px)' }}>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={alertOpen}
        autoHideDuration={6000}
        onClose={() => setAlertOpen(false)}
      >
        <Alert
          variant="filled"
          onClose={() => setAlertOpen(false)}
          severity={alertSeverity}
          sx={{ width: '100%' }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
      <Typography
        variant="h6"
        component="h2"
        gutterBottom
        fontWeight="bold"
        fontStyle="italic"
      >
        {t('rnModule.stage_1.identificationFinishGoods')}
      </Typography>
      <Divider sx={{ width: '100%', mb: 2, bgcolor: '#C09A53' }} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          mb: 2,
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ width: '50%', display: 'block' }}>
          <TextField
            sx={{ width: '90%', mb: 2 }}
            label={t('rnModule.stage_1.rnNumber')}
            variant="outlined"
            value={reportNumber}
            disabled
          />

          <TextField
            sx={{ width: '90%', mb: 2 }}
            label={t('rnModule.fiz_1.materialNumber')}
            variant="outlined"
            value={props.orderProduct.materialNumber}
            disabled
          />
          <TextField
            sx={{ width: '90%', mb: 2 }}
            label={t('rnModule.fiz_1.batch')}
            variant="outlined"
            value={props.orderBatch}
            disabled
          />
          <TextField
            sx={{ width: '90%', mb: 2 }}
            label={t('rnModule.fiz_1.line')}
            variant="outlined"
            value={`Linia ${props.orderBatch.charAt(1)}`}
            disabled
          />
          <TextField
            sx={{ width: '90%', mb: 2 }}
            label={t('rnModule.fiz_1.brand')}
            variant="outlined"
            value={props.orderProduct.brand.description}
            disabled
          />
        </Box>
        <Box sx={{ width: '50%', display: 'block' }}>
          {' '}
          <LocalizationProvider adapterLocale="pl" dateAdapter={AdapterDayjs}>
            <DateTimePicker
              sx={{ width: '90%', mb: 2 }}
              format="DD.MM.YYYY HH:mm"
              views={['year', 'month', 'day', 'hours', 'minutes']}
              label={t('rnModule.stage_1.analyzeDate')}
              value={dayjs(analyzeDate)}
              onChange={(newValue) => {
                setAnalyzeDate(dayjs(newValue));
              }}
              slotProps={{
                textField: {
                  error: false,
                },
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
          <TextField
            sx={{ width: '90%', mb: 2 }}
            label={t('rnModule.fiz_1.material')}
            variant="outlined"
            value={props.orderProduct.description}
            disabled
          />
          <TextField
            sx={{ width: '90%', mb: 2 }}
            label={t('rnModule.fiz_1.orderNumber')}
            variant="outlined"
            value={props.orderNumber}
            disabled
          />
          <TextField
            sx={{ width: '90%', mb: 2 }}
            label={t('rnModule.fiz_1.bbt')}
            variant="outlined"
            value={props.BBT}
            disabled
          />
        </Box>
      </Box>

      {/* Niezgodnosc i pełna identyfikacja niezgodnej partii  */}

      <Typography
        variant="h6"
        component="h2"
        gutterBottom
        fontWeight="bold"
        fontStyle="italic"
      >
        {t('rnModule.fiz_1.identificationDescription')}
      </Typography>
      <Divider sx={{ width: '100%', mb: 2, bgcolor: '#C09A53' }} />

      <Box component={'form'} onSubmit={handleSubmit} sx={{ mb: 2 }}>
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            mb: 2,
          }}
        >
          <Box sx={{ display: 'block', width: '50%' }}>
            <Autocomplete
              disablePortal
              sx={{ width: '90%', mb: 2 }}
              limitTags={2}
              options={props.orderProduct.brand.labSpecification.map((el) => ({
                id: el.parameter.id,
                label: el.parameter.name,
                parameter: el,
              }))}
              onChange={(e, values) => (
                setParameterId(values ? values.id : ''),
                setParameterDes(values ? values.label : ''),
                setParameter(values ? values.parameter : null)
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t('rnModule.fiz_1.inconformity')}
                />
              )}
            />
            <TextField
              sx={{ width: '90%', mb: 2 }}
              label={t('rnModule.fiz_1.specification')}
              variant="outlined"
              value={
                parameter
                  ? `${parameter.specLabel} ${parameter.parameter.unit}`
                  : ''
              }
              disabled
            />
            <TextField
              sx={{ width: '90%', mb: 2 }}
              label={t('rnModule.fiz_1.bbtRelease')}
              variant="outlined"
              value={bbtRelease}
              disabled
            />
            <TextField
              sx={{ width: '90%', mb: 2 }}
              label={t('rnModule.fiz_1.comment')}
              variant="outlined"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
            <TextField
              sx={{ width: '90%', mb: 2 }}
              label={t('rnModule.fiz_1.packagingCode')}
              variant="outlined"
              value={packagingCode}
              onChange={(e) => setPackagingCode(e.target.value)}
            />
            <FormControl>
              <FormLabel>{t('rnModule.fiz_1.beerBlocked')}</FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={radioValue}
                // onChange={handleBeerLock}
              >
                <FormControlLabel
                  value="true"
                  control={<Radio />}
                  label={t('pz04.beerLocked')}
                  disabled
                />
                <FormControlLabel
                  value="false"
                  control={<Radio />}
                  label={t('pz04.beerUnlocked')}
                  disabled
                />
              </RadioGroup>
            </FormControl>
          </Box>
          <Box sx={{ display: 'block', width: '50%' }}>
            <TextField
              sx={{ width: '90%', mb: 2 }}
              label={t('rnModule.fiz_1.analyzeResults')}
              variant="outlined"
              value={analyzeResults}
              onChange={(e) => setAnalyzeResults(e.target.value)}
            />
            <TextField
              sx={{ width: '90%', mb: 2 }}
              label={t('rnModule.fiz_1.releaseRange')}
              variant="outlined"
              value={releaseRange}
              disabled
            />
            <TextField
              sx={{ width: '90%', mb: 2 }}
              label={t('rnModule.fiz_1.releaseZone')}
              variant="outlined"
              value={releaseZone}
              disabled
            />
            <Tooltip
              title={
                <Typography sx={{ fontSize: '15px' }}>
                  {t('rnModule.fiz_1.bbtTooltip')}
                </Typography>
              }
              placement="top"
              slots={{ transition: Zoom }}
            >
              <TextField
                sx={{ width: '90%', mb: 2 }}
                label={t('rnModule.fiz_1.bbtResults')}
                variant="outlined"
                value={bbtResults}
                onChange={(e) => setBbtResults(e.target.value)}
              />
            </Tooltip>
            <TextField
              sx={{ width: '90%', mb: 2 }}
              label={t('rnModule.fiz_1.packagingType')}
              variant="outlined"
              value={packagingType}
              disabled
            />
          </Box>
        </Box>
        <Tooltip
          title={!allowed ? t('rnModule.fiz_1.roleTooltip') : ''}
          placement="top"
          slots={{ transition: Zoom }}
        >
          <Button
            type="submit"
            variant="contained"
            color="primary"
            sx={{ mb: 2 }}
            disabled={
              !['ADMIN', 'LABO', 'SUPER_LABO'].includes(user.users.role)
            }
          >
            {t('rnModule.fiz_1.button.addAnalyzeResults')}
          </Button>
        </Tooltip>
        <Divider sx={{ width: '100%', mb: 2, bgcolor: '#C09A53' }} />
        <TableContainer component={Paper} sx={{ mb: 2 }}>
          <Table sx={{ mb: 2 }}>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>{t('rnModule.fiz_1.table.parameter')}</TableCell>
                <TableCell>{t('rnModule.fiz_1.table.specification')}</TableCell>
                <TableCell>
                  {t('rnModule.fiz_1.table.analyzeResults')}
                </TableCell>
                <TableCell>{t('rnModule.fiz_1.table.releaseRange')}</TableCell>
                <TableCell>{t('rnModule.fiz_1.table.releaseZone')}</TableCell>
                <TableCell>{t('rnModule.fiz_1.table.bbtRelease')}</TableCell>
                <TableCell>{t('rnModule.fiz_1.table.bbtResults')}</TableCell>
                <TableCell>{t('rnModule.fiz_1.table.packagingCode')}</TableCell>
                <TableCell>{t('rnModule.fiz_1.table.comment')}</TableCell>
                <TableCell>{t('rnModule.fiz_1.table.user')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {arrRn_1.map((rn) => (
                <TableRow
                  hover
                  key={rn.id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell>
                    <Button
                      sx={{ color: 'red', p: '0' }}
                      onClick={() => handleRemove(arrRn_1, rn.id)}
                    >
                      <DeleteIcon />
                    </Button>
                  </TableCell>
                  <TableCell>{rn.parameterName}</TableCell>
                  <TableCell>{rn.specification}</TableCell>
                  <TableCell>{rn.analyzeResults}</TableCell>
                  <TableCell>{rn.releaseRange}</TableCell>
                  <TableCell>{rn.releaseZone}</TableCell>
                  <TableCell>{rn.bbtRelease}</TableCell>
                  <TableCell>{rn.bbtResults}</TableCell>
                  <TableCell>{rn.packagingCode}</TableCell>
                  <TableCell>{rn.comment}</TableCell>
                  <TableCell>{`${rn.user.firstName} ${rn.user.lastName}`}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <Divider sx={{ width: '100%', mt: 2, mb: 2, bgcolor: '#C09A53' }} />

      {/* Koniec niezgodnosci  */}

      <Button
        onClick={() => {
          console.log('Final report data:');
        }}
        sx={{
          color: 'white',
          bgcolor: '#C09A53',
          ':hover': { bgcolor: '#9c7c43' },
          height: '40px',
          width: '300px',
          mt: 2,
          mb: 50,
        }}
        disabled={!['ADMIN', 'LABO', 'SUPER_LABO'].includes(user.users.role)}
      >
        {t('rnModule.fiz_1.button.confirmData')}
      </Button>
    </Box>
  );
};

export default RN_Fiz_1;
